import { Component } from '@angular/core';
import { AlertController, LoadingController, NavController, NavParams } from 'ionic-angular';
import { Globals } from "../../../globals";
import { InvoicesServices } from "../services";
import { CustomersServices } from "../../customers/services";
import { CurrencyPipe, DatePipe } from '@angular/common';
import { PrintServices } from '../../services/printServices';
import { TranslateService } from '@ngx-translate/core';
import { AlegraServices } from '../../services/alegraServices';
import { InvoicesListPage } from '../invoices-list/invoices-list';
import moment from 'moment';

/**
 * Generated class for the InvoicesListPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@Component({
  selector: 'page-invoices-view',
  templateUrl: 'invoices-view.html',
})
export class InvoicesViewPage {

  type: any;
  invoice: any;
  customer: any;
  tickets: any;
  total: any;
  subtotal: any;
  iva: any;

  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public loadingCtrl: LoadingController,
    private globals: Globals,
    private invoicesServices: InvoicesServices,
    private customersServices: CustomersServices,
    public alertCtrl: AlertController,
    public cp: CurrencyPipe,
    private printServices: PrintServices,
    public translate: TranslateService,
    private alegraServices: AlegraServices,
    private datePipe: DatePipe) {
    this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Invoices - View', this.globals.restaurant.email, 'View', 'View invoice', 'Income/Expenses', '');

  }

  async ionViewWillEnter() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    this.type = this.navParams.get('type');
    this.invoice = this.navParams.get('invoice');

    this.invoice._created_at = moment(this.globals.timestampToDate(this.invoice.created_at)).format('YYYY-MM-DD');
    if (this.invoice.due_date) {
      this.invoice._due_date = moment(this.globals.timestampToDate(this.invoice.due_date)).format('YYYY-MM-DD');
    } else {
      this.invoice._due_date = '';
    }
    this.customer = await this.customersServices.getCustomer(this.invoice.customer_uid);
    this.tickets = await this.invoicesServices.getListTicketsOfInvoice(this.invoice.list_tickets);
    loadingPopup.dismiss();
    this.getTips();
  }

  payInvoice() {
    //loading
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: ''
    });
    loadingPopup.present();
    //update tickets payment true
    for (let ticket of this.tickets) {
      this.invoicesServices.afs.collection('tickets').doc(ticket.UID).update({
        'list': ticket.list,
        'payment': true,
        'payment_type': 'not specified',
        'pending': false,
      });
      if (ticket.type === 'takeaway') {
        this.invoicesServices.afs.collection('tables').doc(ticket.table_uid).update({
          'ticket.payment': true,
          'ticket.payment_type': 'not specified',
          'ticket.pending': false,
        }).catch(err => { });
      }
    }
    //update invoices
    this.invoicesServices.afs.collection('invoices').doc(this.invoice.UID).update({
      'list_tickets': this.invoice.list_tickets,
      'payed': true,
    }).then(async () => {
      this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Invoices pay - Create', this.globals.restaurant.email, 'Create/Update', 'Pay invoice', 'Income/Expenses', '');

      loadingPopup.dismiss();
      //push root to invoice
      this.navCtrl.pop();
    });
  }

  async createInvoice() {
    //invoice
    var num = await this.invoicesServices.getInvoiceNumber(this.globals.restaurant_uid);
    var number_invoice = num.number;
    //calcular necesario
    var total = 0;
    var subtotal = 0;
    var iva = 0;
    var tax_name = this.globals.user_tax_name;
    var tax_value = this.globals.user_tax;

    //calculate totals
    for (let ticket of this.tickets) {
      var list_taxes = this.globals.showIvaProducts(ticket.list);
      total += list_taxes.total;
      subtotal += list_taxes.subtotal;
      iva += list_taxes.total_tax;
    }
    total = this.globals.roundToTwoDecimals(total);
    //update
    this.invoicesServices.afs.collection('invoices').doc(this.invoice.UID).update({
      'list_tickets': this.invoice.list_tickets,
      'invoice_number': number_invoice,
      'invoice_confirm': true,
      'created_at': new Date(),
      'total': total,
      'subtotal': subtotal,
      'iva': iva,
      'tax_name': tax_name,
      'tax_value': tax_value,
    }).then(async doc => {
      this.globals.GAtrackView('Income/Expenses', 'Income/Expenses - Invoices - Create', this.globals.restaurant.email, 'Create/Update', 'Create invoice', 'Income/Expenses', number_invoice);
      number_invoice++;
      this.invoicesServices.invoiceUpdateNumber(this.globals.restaurant_uid, number_invoice);
      //this.navCtrl.pop();
      //push root a invoices
      this.globals.side_menu_active = 'sales';
      this.navCtrl.setRoot(InvoicesListPage);
    });

  }

  async launchPrepareAndOption(option) {
    this.invoicesServices.prepareAndOption(option, 'view', this.invoice.UID, this.invoice.customer_uid, this.tickets, this.tickets);
  }

  async printInvoice() {
    //
    var _tickets = [];
    var list_taxes = [];

    for (let ticket of this.tickets) {
      //refund
      var refund_reason = '';
      if (ticket.refund_reason) {
        refund_reason = ticket.refund_reason;
      } else {
        refund_reason = '';
      }
      var _ticket = {
        'number': ticket.number + " (" + this.globals.timestampToDate(ticket.date) + ")",
        'amount': ticket.amount,
        'tip': ticket.tip,
        'refund_reason': refund_reason,
      }
      //taxes
      var taxes = this.globals.showIvaProducts(ticket.list);
      list_taxes.push(taxes.taxs);
      //push ticket
      _tickets.push(_ticket);
    }
    var combinedTaxs = this.globals.combineArraysByTax(list_taxes, this.invoice.rectification || false);
    //get invoice
    var invoice_raw = this.invoice;
    //get customer
    var customer_raw = await this.customersServices.getCustomer(this.invoice.customer_uid);
    //format invoice ticket
    this.invoicesServices.invoice_print_ind_number = invoice_raw.invoice_number;
    this.invoicesServices.invoice_print_ind_date = this.globals.timestampToDate(invoice_raw.created_at);
    this.invoicesServices.invoice_print_indv_tickets = _tickets;
    this.invoicesServices.invoice_print_indv_ticket_subtotal = invoice_raw.subtotal;
    this.invoicesServices.invoice_print_indv_ticket_iva = invoice_raw.iva;
    this.invoicesServices.invoice_print_indv_total_ticket = invoice_raw.total;
    this.invoicesServices.invoice_print_indv_cus_name = customer_raw.business_name;
    this.invoicesServices.invoice_print_indv_cus_address = customer_raw.address;
    this.invoicesServices.invoice_print_indv_cus_cif = customer_raw.business_number;
    this.invoicesServices.invoice_print_tips = this.tips;
    this.invoicesServices.invoice_print_indv_taxs = combinedTaxs;
    this.invoicesServices.invoice_payed = invoice_raw.payed;
    this.invoicesServices.invoice_print_indv_rectification = invoice_raw.rectification || false;
    this.invoicesServices.invoice_print_indv_rectified = invoice_raw.rectified || false;
    this.invoicesServices.invoice_print_indv_original_invoice_number = invoice_raw.original_invoice_number;

    if (this.globals.restaurant.printer_type == 'native') {
      let alert = this.alertCtrl.create({
        title: this.translate.instant('instant-imprimir-factura'),
        message: this.translate.instant('instant-seguro-quieres-imprimir-factura'),
        buttons: [
          {
            text: this.translate.instant('general-no'),
            role: 'cancel',
            handler: () => {

            }
          },
          {
            text: this.translate.instant('general-si'),
            handler: () => {
              this.globals.print_content = document.getElementById('print_invoice');
              this.printServices.printNow('print_invoice');
            }
          }
        ]
      });
      alert.present();
    } else {
      this.printServices.prepareInvoice(this.globals.restaurant.printer_type);
    }

  }


  deleteInvoice(invoice) {
    let alert = this.alertCtrl.create({
      title: this.translate.instant('instant-eliminar-factura'),
      message: this.translate.instant('instant-seguro-quieres-eliminar-factura'),
      buttons: [
        {
          text: this.translate.instant('general-no'),
          role: 'cancel',
          handler: () => { }
        },
        {
          text: this.translate.instant('general-si'),
          handler: () => {
            alert.dismiss().then(() => {
              this.handleDeleteInvoice(invoice);
            });
            return false;
          }
        }
      ]
    });
    alert.present();
  }

  private async handleDeleteInvoice(invoice) {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-procesando-solicitud')
    });

    try {
      loadingPopup.present();

      // Verificar que el invoice tenga las propiedades necesarias
      if (!invoice || !invoice.UID) {
        throw new Error('Invalid invoice data');
      }

      this.globals.GAtrackView(
        'Income/Expenses',
        'Income/Expenses - Invoices - Delete',
        this.globals.restaurant.email,
        'Delete',
        'Delete invoice',
        'Income/Expenses',
        invoice.invoice_number || ''
      );

      // Create rectification invoice with safe defaults
      const cloned_invoice = Object.assign({}, invoice);
      cloned_invoice.invoice_number = 'R-' + (invoice.invoice_number || 'UNKNOWN');
      cloned_invoice.created_at = new Date();
      cloned_invoice.rectification = true;
      cloned_invoice.subtotal = invoice.subtotal;
      cloned_invoice.iva = invoice.iva;
      cloned_invoice.total = invoice.total;
      cloned_invoice.original_invoice_uid = invoice.UID;
      cloned_invoice.original_invoice_number = invoice.invoice_number;

      delete cloned_invoice.UID;
      delete cloned_invoice._created_at;
      delete cloned_invoice._due_date;

      // Create rectification invoice and update original invoice status
      await Promise.all([
        this.invoicesServices.afs.collection('invoices').add(cloned_invoice),
        this.invoicesServices.afs.collection('invoices').doc(invoice.UID).update({
          rectified: true,
          rectification_date: new Date(),
          rectification_invoice_number: cloned_invoice.invoice_number
        })
      ]);

      loadingPopup.dismiss();
      
      // Show success message
      let successAlert = this.alertCtrl.create({
        title: this.translate.instant('general-exito'),
        message: this.translate.instant('instant-factura-rectificada-exito'),
        buttons: [{
          text: 'OK',
          handler: () => {
            this.redirect();
          }
        }]
      });
      successAlert.present();

    } catch (error) {
      loadingPopup.dismiss();
      
      let errorAlert = this.alertCtrl.create({
        title: this.translate.instant('general-error'),
        message: this.translate.instant('general-error-creating-rectification'),
        buttons: ['OK']
      });
      errorAlert.present();
    }
  }

  async redirect() {
    let loadingPopup = this.loadingCtrl.create({
      spinner: 'crescent',
      content: this.translate.instant('instant-redirigiendo')
    });
    loadingPopup.present();
    
    try {
      await this.globals.delay(1000);
      this.navCtrl.pop();
    } finally {
      loadingPopup.dismiss();
    }
  }
  //Funcion que crea la factura electronica en alegra
  async createAlegraEInvoice() {
    //date
    let date = this.datePipe.transform(this.invoice.created_at.toDate(), 'yyyy-MM-dd');
    //item
    var id_item = await this.alegraServices.getItemOrCreate();
    var items = [{
      'id': id_item,
      'price': parseFloat(this.invoice.total),
      'quantity': 1
    }];
    //get mct customer
    var customer = await this.customersServices.getCustomer(this.invoice.customer_uid);
    //check alegra customer
    if (customer.alegra_contact_id) {
      //create alegra e invoice
      await this.alegraServices.createAlegraEinvocieAndSaveFirestore(this.invoice, date, date, customer.alegra_contact_id, items);
    } else {
      //call function check customer in alegra
      this.alegraServices.syncronizeMctAlegraCustomers(customer, this.invoice, date, date, items);
    }
  }


  openLink() {
    if (this.globals.so_mobile) {
      window.location.assign('https://app.alegra.com/invoice');
    } else {
      window.open('https://app.alegra.com/invoice', '_blank');
    }
  }

  tips = 0;
  getTips() {
    this.tips = 0;
    for (let ticket of this.tickets) {
      //check tip
      if (ticket.tip && ticket.tip > 0) {
        this.tips += ticket.tip;
      }
    }
    this.tips = Math.abs(this.tips) * (this.tips < 0 ? 1 : -1);
  }

  trFontColor(row) {
    if (row.rectification) {
      return 'text-danger';
    }
    return '';
  }

}



// WEBPACK FOOTER //
// ./src/pages/invoices/invoices-view/invoices-view.ts